import { takeEvery } from 'redux-saga/effects';
import { isolateAudioRequested } from 'features/local-mute/actions';
import {
  audioIsolated,
  hearEveryoneRequested,
  userMutedLocally,
  userUnmutedLocally,
} from 'features/local-mute/localMuteSlice';
import { sessionEnded } from 'features/room/actions';
import {
  signalingUserJoined,
  signalingUserLeft,
  signalingUserLeftBatch,
} from 'features/users/actions';
import { applyLocalMuteSaga } from 'features/local-mute/sagas/applyLocalMuteSaga';
import { isolateAudioSaga } from 'features/local-mute/sagas/isolateAudioSaga';

export default function* localMuteWatcher() {
  yield takeEvery(isolateAudioRequested, isolateAudioSaga);
  yield takeEvery(
    [
      userMutedLocally,
      userUnmutedLocally,
      audioIsolated,
      hearEveryoneRequested,
      signalingUserJoined,
      signalingUserLeft,
      signalingUserLeftBatch,
      sessionEnded,
    ],
    applyLocalMuteSaga
  );
}
